import GlobalConfig from '../lib/GlobalConfig';
export var HEADER_ACTION_LINK_ANIMATE;
(function (HEADER_ACTION_LINK_ANIMATE) {
    HEADER_ACTION_LINK_ANIMATE["SCROLL_UP"] = "SCROLL_UP";
    HEADER_ACTION_LINK_ANIMATE["SCROLL_DOWN"] = "SCROLL_DOWN";
})(HEADER_ACTION_LINK_ANIMATE || (HEADER_ACTION_LINK_ANIMATE = {}));
class HeaderConfig {
    constructor() {
        this.headerMenu = {
            templates: {
                name: 'Templates',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    'marketing-video-templates': {
                        name: 'Marketing Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/marketing-videos/`,
                    },
                    'business-video-templates': {
                        name: 'Business Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/business-videos/`,
                    },
                    'youTube-video-templates': {
                        name: 'YouTube Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/youtube-videos/`,
                    },
                    'slideshow-templates': {
                        name: 'Slideshow Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/slideshows/`,
                    },
                    'outro-video-templates': {
                        name: 'Outro Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/outro-videos/`,
                    },
                    'intro-video-templates': {
                        name: 'Intro Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/intro-videos/`,
                    },
                    'advertisement-video-templates': {
                        name: 'Advertisement Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/advertisement-videos/`,
                    },
                    'real-estate-video-templates': {
                        name: 'Real Estate Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/real-estate-videos/`,
                    },
                    'social-media-video-templates': {
                        name: 'Social Media Video Templates',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/social-media-videos/`,
                    },
                    'view-all': {
                        name: 'View all',
                        type: 'leaf',
                        url: `{{ host_url }}/templates/`,
                        icon: this.ANGLE_RIGHT_ICON_BLUE_MOBILE,
                        color: 'iv-text-blue',
                    },
                },
            },
            explore: {
                name: 'Explore',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    'invideo-is-for': {
                        name: `{{ siteId }} is for`,
                        type: 'nested',
                        icon: this.ANGLE_RIGHT_ICON_MOBILE,
                        links: {
                            'online-video-editor': {
                                name: 'Online Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/online-video-editor/',
                            },
                            'intro-maker': {
                                name: 'Intro Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/free-intro-maker-without-watermark/',
                            },
                            'outro-maker': {
                                name: 'Outro Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/outro-maker/',
                            },
                            'slideshow-maker': {
                                name: 'Slideshow Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/slideshow-maker/',
                            },
                            'ad-maker': {
                                name: 'Video Ad Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/ad-maker/',
                            },
                            'youtube-intro-maker': {
                                name: 'Youtube Intro Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/youtube-intro-maker/',
                            },
                            'birthday-video-maker': {
                                name: 'Birthday Video Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/birthday-video-maker/',
                            },
                            'instagram-ad-maker': {
                                name: 'Instagram Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/instagram-video-editor/',
                            },
                            'meme-generator': {
                                name: 'Invitation Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/invitation-maker/',
                            },
                        },
                    },
                    'app-promo': {
                        type: 'leaf',
                        name: 'InVideo on App & Play store',
                        external: true,
                        icon: {
                            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/arrow-top-right.svg`,
                            alt: 'arrow top right',
                            placement: 'suffix',
                            width: 8,
                            height: 8,
                        },
                        url: GlobalConfig.APP_PROMO_LINKS.mobile.Android.url,
                        platform: 'mobile',
                    },
                    'mobile-app': {
                        name: 'Mobile App',
                        type: 'nested',
                        platform: 'desktop',
                    },
                },
            },
            learn: {
                name: 'Learn',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    tutorials: {
                        name: 'Tutorials',
                        type: 'leaf',
                        url: 'https://help-studio.invideo.io',
                        external: true,
                    },
                    youtube: {
                        name: 'Youtube Channel',
                        type: 'leaf',
                        linkKey: '{{youtube_header_link}}',
                        external: true,
                    },
                    instagram: {
                        name: 'Instagram Inspiration',
                        type: 'leaf',
                        linkKey: '{{instagram_header_link}}',
                        external: true,
                    },
                    facebook: {
                        name: 'Facebook Community',
                        type: 'leaf',
                        url: 'https://www.facebook.com/groups/invideo.io/',
                        external: true,
                    },
                    blog: {
                        name: 'Blog',
                        type: 'leaf',
                        url: 'https://invideo.io/blog/',
                    },
                },
            },
            support: {
                name: 'Support',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    'live-chat': {
                        name: 'Live chat 24/7',
                        type: 'leaf',
                        linkKey: '{{header_live_chat}}',
                    },
                    'email-us': {
                        name: 'Email us',
                        type: 'leaf',
                        url: 'mailto:support@invideo.io',
                        external: true,
                    },
                },
            },
            pricing: {
                name: 'Pricing',
                type: 'leaf',
                url: `{{ host_url }}/studio-pricing`,
            },
        };
        this.headerMenuV2 = {
            invideoStudio: {
                name: 'invideo Studio',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                color: 'iv-text-hot-pink',
                layout: 'flex',
                links: {
                    'invideo-studio': {
                        name: `invideo Studio`,
                        type: 'nested',
                        showAuth: 'STUDIO',
                        links: {
                            'online-video-editor': {
                                name: 'Online Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/online-video-editor/',
                            },
                            'video-collage-maker': {
                                name: 'Video Collage Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/video-collage-maker/',
                            },
                            'picture-video-maker': {
                                name: 'Picture Video Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/picture-video-maker/',
                            },
                            'instagram-video-editor': {
                                name: 'Instagram Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/instagram-video-editor/',
                            },
                            'online-video-maker': {
                                name: 'Online Video Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/video-maker/',
                            },
                            'facebook-video-editor': {
                                name: 'Facebook Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/facebook-video-editor/',
                            },
                            'add-music-to-video': {
                                name: 'Add Music to Video',
                                type: 'leaf',
                                url: 'https://invideo.io/make/add-music-to-video-online/',
                            },
                            'add-text-to-gif': {
                                name: 'Add Text to GIF',
                                type: 'leaf',
                                url: 'https://invideo.io/make/add-text-to-gif/',
                            },
                            'video-compressor': {
                                name: 'Video Compressor',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/compress/video-compressor/',
                            },
                            'mp4-compressor': {
                                name: 'MP4 Compressor',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/compress/mp4-compressor/',
                            },
                            'video-converter': {
                                name: 'Video Converter',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/convert/video-converter/',
                            },
                            'video-trimmer': {
                                name: 'Video Trimmer',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/video-trimmer/',
                            },
                        },
                    },
                    templates: {
                        name: `Templates`,
                        type: 'nested',
                        color: 'iv-text-black-85',
                        links: {
                            'business-video-templates': {
                                name: 'Business Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/business-videos/`,
                            },
                            'youTube-video-templates': {
                                name: 'YouTube Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/youtube-videos/`,
                            },
                            'slideshow-templates': {
                                name: 'Slideshow Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/slideshows/`,
                            },
                            'outro-video-templates': {
                                name: 'Outro Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/outro-videos/`,
                            },
                            'intro-video-templates': {
                                name: 'Intro Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/intro-videos/`,
                            },
                            'advertisement-video-templates': {
                                name: 'Advertisement Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/advertisement-videos/`,
                            },
                            'real-estate-video-templates': {
                                name: 'Real Estate Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/real-estate-videos/`,
                            },
                            'social-media-video-templates': {
                                name: 'Social Media Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/social-media-videos/`,
                            },
                            'view-all': {
                                name: 'View all',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/`,
                                icon: this.ANGLE_RIGHT_ICON_BLUE_MOBILE,
                                color: 'iv-text-blue',
                            },
                        },
                    },
                },
            },
            invideoAi: {
                name: 'invideo AI',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    'invideo-ai': {
                        name: `invideo AI`,
                        type: 'nested',
                        showAuth: 'AI',
                        links: {
                            'ai-video-generator': {
                                name: `AI Video Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-video-generator/`,
                            },
                            'sora-2-x-invideo': {
                                name: `Sora 2 x Invideo`,
                                type: 'leaf',
                                url: `https://invideo.io/make/sora/`,
                            },
                            'veo-3.1-x-invideo': {
                                name: `Veo 3.1 x Invideo`,
                                type: 'leaf',
                                url: `https://invideo.io/make/googleveo/`,
                            },
                            'ai-avatar-generator': {
                                name: `AI Avatar Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-avatar-generator/`,
                            },
                            'ugc-ads': {
                                name: `UGC Ads`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ugc-ads/`,
                            },
                            'ai-image-generator': {
                                name: `AI Image Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/ai/ai-image-generator/`,
                            },
                            'animation-maker': {
                                name: `Animation Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-animation-generator/`,
                            },
                            'link-to-video': {
                                name: `Link to Video`,
                                type: 'leaf',
                                url: `https://invideo.io/make/link-to-video/`,
                            },
                            'movie-maker': {
                                name: `Movie Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/online-movie-maker/`,
                            },
                            'ai-video-meme-generator': {
                                name: `AI Video Meme Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/meme-generator/`,
                            },
                            'tiktok-video-maker': {
                                name: `TikTok Video Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/tiktok-video-editor/`,
                            },
                            'ai-clip-generator': {
                                name: `AI Clip Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/clipmaker/`,
                            },
                            'youtube-shorts-maker': {
                                name: `Youtube Shorts Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-youtube-shorts-generator/`,
                            },
                            'ai-subtitle-generator': {
                                name: `AI Subtitle Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-subtitle-generator/`,
                            },
                            'voiceover-generator': {
                                name: `Voiceover Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/tools/ai-voiceover-generator/`,
                            },
                            'slideshow-maker': {
                                name: `Slideshow Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/slideshow-maker/`,
                            },
                        },
                    },
                },
            },
            help: {
                name: 'Help',
                type: 'nested',
                layout: 'flex',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    support: {
                        name: 'Support',
                        type: 'nested',
                        links: {
                            'live-chat': {
                                name: 'Contact support',
                                type: 'leaf',
                                linkKey: '{{header_live_chat}}',
                            },
                            'email-us': {
                                name: 'Email us',
                                type: 'leaf',
                                url: 'mailto:support@invideo.io',
                                external: true,
                            },
                            tutorials: {
                                name: 'Tutorials',
                                type: 'leaf',
                                url: 'https://help-studio.invideo.io',
                                external: true,
                            },
                        },
                    },
                    learn: {
                        name: 'Learn',
                        type: 'nested',
                        links: {
                            youtube: {
                                name: 'Youtube Channel',
                                type: 'leaf',
                                linkKey: '{{youtube_header_link}}',
                                external: true,
                            },
                            instagram: {
                                name: 'Instagram Inspiration',
                                type: 'leaf',
                                linkKey: '{{instagram_header_link}}',
                                external: true,
                            },
                            blog: {
                                name: 'Blog',
                                type: 'leaf',
                                url: 'https://invideo.io/blog/',
                            },
                        },
                    },
                },
            },
            community: {
                name: 'Community',
                type: 'leaf',
                url: 'https://www.facebook.com/groups/invideo.io/',
                external: true,
            },
            pricing: {
                name: 'Pricing',
                type: 'leaf',
                url: `{{ host_url }}/studio-pricing`,
            },
        };
        this.headerMenuAI = {
            invideoAi: {
                name: 'invideo AI',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                color: 'iv-text-hot-pink',
                links: {
                    'invideo-ai': {
                        name: `invideo AI`,
                        type: 'nested',
                        showAuth: 'AI',
                        links: {
                            'ai-video-generator': {
                                name: `AI Video Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-video-generator/`,
                            },
                            'sora-2-x-invideo': {
                                name: `Sora 2 x Invideo`,
                                type: 'leaf',
                                url: `https://invideo.io/make/sora/`,
                            },
                            'veo-3.1-x-invideo': {
                                name: `Veo 3.1 x Invideo`,
                                type: 'leaf',
                                url: `https://invideo.io/make/googleveo/`,
                            },
                            'ai-avatar-generator': {
                                name: `AI Avatar Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-avatar-generator/`,
                            },
                            'ugc-ads': {
                                name: `UGC Ads`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ugc-ads/`,
                            },
                            'ai-image-generator': {
                                name: `AI Image Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/ai/ai-image-generator/`,
                            },
                            'animation-maker': {
                                name: `Animation Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-animation-generator/`,
                            },
                            'link-to-video': {
                                name: `Link to Video`,
                                type: 'leaf',
                                url: `https://invideo.io/make/link-to-video/`,
                            },
                            'movie-maker': {
                                name: `Movie Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/online-movie-maker/`,
                            },
                            'ai-video-meme-generator': {
                                name: `AI Video Meme Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/meme-generator/`,
                            },
                            'tiktok-video-maker': {
                                name: `TikTok Video Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/tiktok-video-editor/`,
                            },
                            'ai-clip-generator': {
                                name: `AI Clip Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/clipmaker/`,
                            },
                            'youtube-shorts-maker': {
                                name: `Youtube Shorts Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-youtube-shorts-generator/`,
                            },
                            'ai-subtitle-generator': {
                                name: `AI Subtitle Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/make/ai-subtitle-generator/`,
                            },
                            'voiceover-generator': {
                                name: `Voiceover Generator`,
                                type: 'leaf',
                                url: `https://invideo.io/tools/ai-voiceover-generator/`,
                            },
                            'slideshow-maker': {
                                name: `Slideshow Maker`,
                                type: 'leaf',
                                url: `https://invideo.io/make/slideshow-maker/`,
                            },
                        },
                    },
                },
            },
            invideoStudio: {
                name: 'invideo Studio',
                type: 'nested',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                layout: 'flex',
                links: {
                    'invideo-studio': {
                        name: `invideo Studio`,
                        type: 'nested',
                        showAuth: 'STUDIO',
                        links: {
                            'online-video-editor': {
                                name: 'Online Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/online-video-editor/',
                            },
                            'video-collage-maker': {
                                name: 'Video Collage Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/video-collage-maker/',
                            },
                            'picture-video-maker': {
                                name: 'Picture Video Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/picture-video-maker/',
                            },
                            'instagram-video-editor': {
                                name: 'Instagram Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/instagram-video-editor/',
                            },
                            'online-video-maker': {
                                name: 'Online Video Maker',
                                type: 'leaf',
                                url: 'https://invideo.io/make/video-maker/',
                            },
                            'facebook-video-editor': {
                                name: 'Facebook Video Editor',
                                type: 'leaf',
                                url: 'https://invideo.io/make/facebook-video-editor/',
                            },
                            'add-music-to-video': {
                                name: 'Add Music to Video',
                                type: 'leaf',
                                url: 'https://invideo.io/make/add-music-to-video-online/',
                            },
                            'add-text-to-gif': {
                                name: 'Add Text to GIF',
                                type: 'leaf',
                                url: 'https://invideo.io/make/add-text-to-gif/',
                            },
                            'video-compressor': {
                                name: 'Video Compressor',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/compress/video-compressor/',
                            },
                            'mp4-compressor': {
                                name: 'MP4 Compressor',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/compress/mp4-compressor/',
                            },
                            'video-converter': {
                                name: 'Video Converter',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/convert/video-converter/',
                            },
                            'video-trimmer': {
                                name: 'Video Trimmer',
                                type: 'leaf',
                                url: 'https://invideo.io/tools/video-trimmer/',
                            },
                        },
                    },
                    templates: {
                        name: `Templates`,
                        type: 'nested',
                        color: 'iv-text-black-85',
                        links: {
                            'business-video-templates': {
                                name: 'Business Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/business-videos/`,
                            },
                            'youTube-video-templates': {
                                name: 'YouTube Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/youtube-videos/`,
                            },
                            'slideshow-templates': {
                                name: 'Slideshow Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/slideshows/`,
                            },
                            'outro-video-templates': {
                                name: 'Outro Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/outro-videos/`,
                            },
                            'intro-video-templates': {
                                name: 'Intro Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/intro-videos/`,
                            },
                            'advertisement-video-templates': {
                                name: 'Advertisement Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/advertisement-videos/`,
                            },
                            'real-estate-video-templates': {
                                name: 'Real Estate Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/real-estate-videos/`,
                            },
                            'social-media-video-templates': {
                                name: 'Social Media Video Templates',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/social-media-videos/`,
                            },
                            'view-all': {
                                name: 'View all',
                                type: 'leaf',
                                url: `{{ host_url }}/templates/`,
                                icon: this.ANGLE_RIGHT_ICON_BLUE_MOBILE,
                                color: 'iv-text-blue',
                            },
                        },
                    },
                },
            },
            help: {
                name: 'Help',
                type: 'nested',
                layout: 'flex',
                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                links: {
                    support: {
                        name: 'Support',
                        type: 'nested',
                        links: {
                            'live-chat': {
                                name: 'Contact support',
                                type: 'leaf',
                                linkKey: '{{header_live_chat}}',
                            },
                            'email-us': {
                                name: 'Email us',
                                type: 'leaf',
                                url: 'mailto:support@invideo.io',
                                external: true,
                            },
                            tutorials: {
                                name: 'Tutorials',
                                type: 'leaf',
                                url: 'https://help.invideo.io',
                                external: true,
                            },
                        },
                    },
                    learn: {
                        name: 'Learn',
                        type: 'nested',
                        links: {
                            youtube: {
                                name: 'Youtube Channel',
                                type: 'leaf',
                                linkKey: '{{youtube_header_link}}',
                                external: true,
                            },
                            instagram: {
                                name: 'Instagram Inspiration',
                                type: 'leaf',
                                linkKey: '{{instagram_header_link}}',
                                external: true,
                            },
                            blog: {
                                name: 'Blog',
                                type: 'leaf',
                                url: 'https://invideo.io/blog/',
                            },
                        },
                    },
                },
            },
            community: {
                name: 'Community',
                type: 'leaf',
                url: 'https://discord.gg/invideo-ai',
                links: {},
            },
            pricing: {
                name: 'Pricing',
                type: 'leaf',
                url: `{{ host_url }}/pricing/`,
            },
        };
    }
    get LOGO_ICON() {
        return `${GlobalConfig.cdn.SHARED_URL}/logos/invideo-logo.svg`;
    }
    get BACK_ICON_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/chevron-left.svg`,
            alt: 'chevron left',
            placement: 'prefix',
            width: 6,
            height: 10,
        };
    }
    get ANGLE_RIGHT_ICON_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/angle-right.svg`,
            alt: 'angle right',
            placement: 'suffix',
            width: 6,
            height: 10,
        };
    }
    get ANGLE_BOTTOM_ICON_DESKTOP() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/angle-bottom-v1.svg`,
            alt: 'angle bottom',
            placement: 'suffix',
            width: 8,
            height: 8,
        };
    }
    get ANGLE_RIGHT_ICON_BLUE_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/angle-right-blue.svg`,
            alt: 'angle right blue',
            placement: 'suffix',
            width: 6,
            height: 10,
        };
    }
    get HEART_ICON_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/heart.svg`,
            alt: 'angle right',
            placement: 'suffix',
            width: 20,
            height: 16,
        };
    }
    get BAR_ICON_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/bar.svg`,
            placement: 'suffix',
            alt: 'bar',
            width: 17,
            height: 9,
        };
    }
    get MENU() {
        return this.headerMenu;
    }
    get MENU_V2() {
        return this.headerMenuV2;
    }
    get MENU_AI() {
        return this.headerMenuAI;
    }
    get PROFILE_MENU_LINKS() {
        return [
            {
                name: 'Profile',
                type: 'generalUser',
                url: '/user/profile',
            },
            {
                name: 'Dashboard',
                type: 'generalUser',
                url: '/dashboard',
            },
            {
                name: 'My Projects',
                type: 'generalUser',
                url: '/videos',
            },
            {
                name: 'Brand Presets',
                type: 'generalUser',
                url: '/account',
            },
            {
                name: 'Team Settings',
                type: 'team',
                url: '/account/team-settings',
            },
            {
                name: 'Subscription Plan',
                type: 'nonEditor',
                url: '/user/subscription',
            },
            {
                name: 'Purchased',
                type: 'all',
                url: '/workflow/marketing-templates/purchased',
            },
        ];
    }
    set HeaderExplore(exploreLinks) {
        this.headerMenu.explore.links = exploreLinks;
    }
    get HEADER_LINKS() {
        return {
            logoRedirection: {
                loggedInURL: `${GlobalConfig.HOST_URL}`,
                nonLoggedInURL: `${GlobalConfig.HOST_URL}/workflow/marketing-templates`,
            },
            upgradeRedirectURL: `${GlobalConfig.HOST_URL}/user/subscription`,
            favouritesRedirectURL: `${GlobalConfig.HOST_URL}/workflow/marketing-templates/favourites`,
            userProfile: `${GlobalConfig.HOST_URL}/user/profile`,
        };
    }
}
export default new HeaderConfig();
